package gr.tech.GRAttestation.components.inputs

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.disabled
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.models.storeusers.STORE_USERS_STATUS
import gr.tech.GRAttestation.styles.GeneralInputErrorStyle
import gr.tech.GRAttestation.styles.InputContainerStyle
import gr.tech.GRAttestation.styles.bsInputLabelStyle
import gr.tech.GRAttestation.styles.bsInputStyle
import org.jetbrains.compose.web.attributes.required
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.dom.*

private val statusOptions = listOf(
    STORE_USERS_STATUS.ACTIVE,
    STORE_USERS_STATUS.DISABLED
)

@Composable
fun StoreUserStatusDropdown(
    inputId: String = "storeUserStatusDropdown",
    labelText: String = "Status",
    isInvite: Boolean = false,
    selected: STORE_USERS_STATUS = STORE_USERS_STATUS.ACTIVE,
    hasError: Boolean = false,
    labelModifier: Modifier = Modifier.bsInputLabelStyle(),
    selectModifier: Modifier = Modifier.bsInputStyle(),
    onValueChange: (STORE_USERS_STATUS) -> Unit
) {

    Div(
        attrs = InputContainerStyle.toModifier()
            .flexDirection(FlexDirection.Column)
            .toAttrs()
    ) {
        Label(
            forId = inputId,
            attrs = labelModifier.toAttrs()
        ) {
            Text(labelText)
        }

        val options = if (isInvite) listOf(selected) else statusOptions

        Select(
            attrs = selectModifier
                .thenIf(
                    condition = isInvite,
                    other = Modifier.classNames("disabled")
                )
                .id(inputId)
                .thenIf(hasError, GeneralInputErrorStyle.toModifier())
                .toAttrs {
                    required()
                    disabled(isInvite)
                    onChange { event ->
                        onValueChange(STORE_USERS_STATUS.parseStatus(event.target.value))
                    }
                }
        ) {
            options.forEach { status ->
                Option(
                    value = status.status,
                    attrs = Modifier.toAttrs {
                        if (status == selected) attr("selected", "")
                    }
                ) {
                    Text(status.status.lowercase().replaceFirstChar { it.uppercase() })
                }
            }
        }
    }
}
